import React from 'react';
import { Heart, Instagram, Mail } from 'lucide-react';
const Footer = () => {
  return <footer className="bg-sage bg-opacity-30 py-12" data-id="element-57">
      <div className="max-w-5xl mx-auto px-4 text-center" data-id="element-58">
        <h2 className="font-script text-4xl mb-2 text-gray-800" data-id="element-59">
          Ayevbosa & Abiodun
        </h2>
        <p className="text-gray-700 mb-6 font-elegant" data-id="element-60">
          February 14, 2026 • Ibadan, Oyo State
        </p>
        <div className="w-16 h-0.5 bg-emerald mx-auto mb-6" data-id="element-61"></div>
        <div className="flex justify-center space-x-6 mb-8" data-id="element-62">
          <a href="#" className="text-gray-600 hover:text-emerald transition-colors" data-id="element-63">
            <Instagram size={24} data-id="element-64" />
          </a>
          <a href="mailto:ayevbosa.abiodun@example.com" className="text-gray-600 hover:text-emerald transition-colors" data-id="element-65">
            <Mail size={24} data-id="element-66" />
          </a>
        </div>
        <p className="text-gray-600 flex items-center justify-center text-sm" data-id="element-67">
          Made with <Heart size={14} className="text-emerald mx-1" data-id="element-68" /> for our
          special day
        </p>
      </div>
    </footer>;
};
export default Footer;